var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m505.661 271.254-113.935-85.828a15.914 15.914 0 0 0-25.492 12.709v45.343H133.241a6.735 6.735 0 0 0-.773.039A12.514 12.514 0 0 0 120.717 256v39.549L31.1 228.039l89.621-67.512V200.4a12.515 12.515 0 0 0 11.751 12.486 6.972 6.972 0 0 0 .773.039h177.1a12.525 12.525 0 1 0 0-25.049H145.766v-45.667a15.915 15.915 0 0 0-25.49-12.712L6.339 215.328a15.915 15.915 0 0 0 0 25.423l113.935 85.828c9.936 8.019 25.92.016 25.492-12.71v-45.342h232.993a9.753 9.753 0 0 0 1.014-.052A12.517 12.517 0 0 0 391.283 256v-39.547l89.617 67.512-89.621 67.513V311.6a12.516 12.516 0 0 0-11.605-12.478 8.785 8.785 0 0 0-.919-.046h-177.1a12.524 12.524 0 1 0 0 25.048h164.579V369.8c-.428 12.727 15.555 20.725 25.49 12.711l113.937-85.831a15.914 15.914 0 0 0 0-25.422z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.37e5a497caca343af79e4e0e15c52d8d.svg";
export { ForwardRef as ReactComponent };